export interface Testimonial {
  name: string;
  role: string;
  avatar: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: '小雨',
    role: '健身爱好者 · 训练8个月',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20warm%20neutral%20tones%2C%20lifestyle%20portrait%20photography%2C%20high%20detail%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-01&orientation=squarish',
    content: '从完全不懂怎么练臀到现在，8个月臀围增加了5cm！最感谢的是这里把每个动作都讲得特别清楚，尤其是臀部激活那篇文章，彻底解决了我的腰部代偿问题。现在每次训练都能精准找到臀部发力感。',
    rating: 5,
  },
  {
    name: 'Catherine',
    role: '上班族 · 居家训练1年',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Asian%20woman%20with%20confident%20expression%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20warm%20neutral%20tones%2C%20lifestyle%20portrait%20photography%2C%20high%20detail%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-02&orientation=squarish',
    content: '作为一个996上班族，根本没时间去健身房。靠这里的居家训练方案和弹力带教程，在家也能高效练臀。最实用的是25分钟训练计划，午休时间就能搞定，坚持一年下来效果非常明显！',
    rating: 5,
  },
  {
    name: '小鹿',
    role: '新手妈妈 · 产后恢复',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20woman%20with%20gentle%20smile%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20warm%20neutral%20tones%2C%20lifestyle%20portrait%20photography%2C%20high%20detail%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-03&orientation=squarish',
    content: '产后身体走样严重，臀部下垂让我很没自信。跟着这里的方案从最基础的臀桥开始，一步步恢复。不仅臀部形态改善了，腰也不酸了，整个人的体态都变好了。强烈推荐给产后妈妈！',
    rating: 5,
  },
  {
    name: 'Amanda',
    role: '健身博主 · 训练3年',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20fit%20Asian%20woman%20with%20athletic%20look%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20warm%20neutral%20tones%2C%20lifestyle%20portrait%20photography%2C%20high%20detail%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-04&orientation=squarish',
    content: '作为一个健身博主，我看过太多不靠谱的健身内容。这里的文章质量真的高，尤其是臀推完全指南和渐进超负荷那两篇，专业度不输运动科学论文，但又通俗易懂。我现在经常推荐粉丝来这里学习基础知识。',
    rating: 5,
  },
];